export const FormValue = {
  when: {
    NOW: '0',
    LTMONTH: '1',
    LTTWOMONTH: '2',
    GTTWOMONTH: '3',
  },
  who: {
    SINGLE: 'single',
    SHARED: 'shared',
    COUPLE: 'couple',
    FAMILY: 'family',
  },
  unionType: {
    married: 'married',
    pacs: 'pacs',
    union: 'union',
  },
  proSituation: {
    EMPLOYED: 'employed',
    UNEMPLOYED: 'unemployed',
    RETIRED: 'retired',
    STUDENT: 'student',
    WITHOUT_ACTIVITY: 'without_activity',
  },
  proStatus: {
    STUDENT: 'student',
    CDI: 'cdi',
    CDI_PROBATION: 'cdi_probation',
    CDD: 'cdd',
    CIVIL_SERVANT: 'civil_servant',
    SELF_EMPLOYED: 'self_employed',
    TRADER: 'trader',
    CEO: 'ceo',
    RETIRED: 'retired',
    BENEFITS: 'benefits',
    UNEMPLOYED: 'unemployed',
    RSA: 'rsa',
  },
  guarantorType: {
    FAMILY: 'family',
    FRIEND: 'friend',
    COMPANY_BANK: 'company_bank',
    VISALE: 'visale',
    ONLINE_SERVICE: 'online_service',
  },
  buyingReason: {
    PRI: 'pri',
    INV: 'inv',
    SEC: 'sec',
  },
  financeOrigin: {
    OWN: 'own',
    BNK: 'bnk',
  },
  companyCreation: {
    COMPANY_CREATED: 'true',
    COMPANY_IN_PROCESS: 'false',
  },
}
